/**
 * Checkbox — vendored from shadcn/ui on @radix-ui/react-checkbox (style guide
 * §7.3): 18px, radius-sm, 1.5px navy-500 border, primary fill with a white 12px
 * check when checked. Acknowledgment checkboxes that gate a primary action use
 * body text for the label and keep the button disabled until checked.
 */
import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check, Minus } from 'lucide-react'

import { cn } from './cn'

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer inline-flex size-[18px] shrink-0 items-center justify-center rounded-sm border-[1.5px] border-navy-500 bg-white transition-colors duration-[var(--duration-fast)]',
      'hover:border-navy-600 focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]',
      'disabled:cursor-not-allowed disabled:opacity-45',
      'data-[state=checked]:border-navy-950 data-[state=checked]:bg-navy-950 data-[state=checked]:text-white',
      'data-[state=indeterminate]:border-navy-950 data-[state=indeterminate]:bg-navy-950 data-[state=indeterminate]:text-white',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      {props.checked === 'indeterminate' ? (
        <Minus className="size-3" strokeWidth={3} aria-hidden />
      ) : (
        <Check className="size-3" strokeWidth={3} aria-hidden />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName
